
// Accordion content
jQuery(document).ready(function () {
  jQuery(".accordion-content").on("show.bs.collapse", function () {
    // var id = jQuery(this).attr("data-service-id");

    // Hide all asides
    //jQuery(".card-aside").removeClass('inplace');

    // Show this aside
    //jQuery("#card-aside-" + id).addClass('inplace');

    var element_id = jQuery(this).attr("id");
    console.log(element_id);
    // This accordion
    var this_accordion_id = jQuery(this).attr("data-parent"); // has hash

    // Fidn the parent card and add active to it.
    jQuery(this_accordion_id + " .card").removeClass("active");
    jQuery(this_accordion_id + " .card").removeClass("inplace");
    jQuery("#" + element_id)
      .parent()
      .parent()
      .addClass("active");

    // Add inplace after .2 seconds
    setTimeout(function () {
      jQuery("#" + element_id)
        .parent()
        .parent()
        .addClass("inplace");
    }, 220);
  });

  // Add data-featherlight="image" to the first link in each grid item.

  jQuery(".lightbox-grid").each(function (index, element) {
    jQuery(element)
      .find(".grid-item")
      .each(function (index2, element2) {
        // Do something with each inner element
        jQuery(element2).find("a").first().attr("data-featherlight", "image");
      });
  });
});


// Make tabbed content have the same height.
window.addEventListener("load", function () {
  document.querySelectorAll(".tabbed-content.tabs-eq-height .bs-tabs.accordion").forEach(function (acc) {
    var panes = acc.querySelectorAll(".card .collapse"); // the collapsible wrappers
    if (!panes.length) return;

    var max = 0;

    panes.forEach(function (pane) {
      var body = pane.querySelector(".card-body");
      if (!body) return;

      // Save original inline styles + show state
      var wasShown = pane.classList.contains("show");
      var prevStyle = pane.getAttribute("style");

      // Make it measurable without flashing
      pane.classList.add("show");
      pane.style.display = "block";
      pane.style.height = "auto";
      pane.style.visibility = "hidden";
      pane.style.position = "absolute";
      pane.style.pointerEvents = "none";
      pane.style.left = "-99999px";
      pane.style.top = "0";

      // Measure natural content height
      var h = body.scrollHeight;
      if (h > max) max = h;

      // Restore state
      if (!wasShown) pane.classList.remove("show");
      if (prevStyle !== null) {
        pane.setAttribute("style", prevStyle);
      } else {
        pane.removeAttribute("style");
      }
    });

    // Apply min-height to all bodies
    acc.querySelectorAll(".card .card-body").forEach(function (b) {
      b.style.minHeight = max + "px";
    });
  });
});


// Slider bullet feature
function restartActiveBulletAnimation(swiper) {
  // Only if pagination exists
  var bullets = swiper.el.querySelectorAll(".swiper-pagination-bullet");
  if (!bullets.length) return;

  // Clear any existing animation flags
  bullets.forEach(function (b) {
    b.classList.remove("is-animating");
  });

  var active = swiper.el.querySelector(".swiper-pagination-bullet-active");
  if (!active) return;

  // Force reflow so animation restarts reliably
  void active.offsetWidth;
  active.classList.add("is-animating");
}